import React, { useState, useEffect } from "react";

const LicenseForm = ({ initialLicense, onSubmit }) => {
  const [licenseChecked, setLicenseChecked] = useState(null);

  useEffect(() => {
    setLicenseChecked(initialLicense);
  }, [initialLicense]);

  const submit = (e) => {
    e.preventDefault();
    onSubmit(licenseChecked);
  };

  return (
    <form className="p-3 border rounded">
        <div className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id={"hasLicense"}
            checked={licenseChecked}
            onChange={() => setLicenseChecked(!licenseChecked)}
          />
          <label className="form-check-label" htmlFor={"hasLicense"}>
            <strong>{"Operator Eligability"}</strong> – {"Will the operator be in possession of a boating safety certificate at the time of the rental OR were they born before July 1, 1996?"}
          </label>
        </div>

      <div className="modal-btn-container mt-3">
        <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>
    </form>
  );
};

export default LicenseForm;
